export default __webpack_public_path__ + "static/media/logo-xl-1024w.fa35470e.png";